<template>
  <div id="EventList">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">活動列表</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">活動</li>
              <li class="breadcrumb-item active">活動列表</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="event" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-9">
            <div class="filter">
              <el-button @click="selectByType(1)" :class="{ current: 1 == filterParam.Quarter }">上年度</el-button>
              <el-button @click="selectByType(2)" :class="{ current: 2 == filterParam.Quarter }">本年度</el-button>
              <el-button @click="selectByType(3)" :class="{ current: 3 == filterParam.Quarter }">下年度</el-button>
              <el-button @click="selectByType(4)" :class="{ current: 4 == filterParam.Quarter }">過去90天</el-button>
              <el-button @click="selectByType(5)" :class="{ current: 5 == filterParam.Quarter }">過去30天</el-button>
              <el-button @click="selectByType(6)" :class="{ current: 6 == filterParam.Quarter }">過去14天</el-button>
              <el-button @click="selectByType(7)" :class="{ current: 7 == filterParam.Quarter }">過去7天至未來所有</el-button>
              <el-button @click="selectByType(8)" :class="{ current: 8 == filterParam.Quarter }">未來14天</el-button>
              <el-button @click="selectByType(9)" :class="{ current: 9 == filterParam.Quarter }">未來30天</el-button>
              <el-button @click="selectByType(10)" :class="{ current: 10 == filterParam.Quarter }">未來90天</el-button>
            </div>
          </div>
          <div class="col-sm-1"></div>
          <div class="col-sm-2">
            <button type="button" class="btn btn-block btn-primary btn-sm" value="新增活動" @click="toEventAdd()">
              <i class="nav-icon fas fa-plus fa-sm mr-1"></i> 新增活動
            </button>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-1">
            <el-input placeholder="搜尋活動名稱" v-model="filterParam.title"></el-input>
          </div>

          <div class="col-sm-1">
            <el-select v-model="filterParam.area" clearable placeholder="舉辦地區">
              <el-option v-for="Area in EventCityList" :key="Area.id" :label="Area.sgL_NewName"
                :value="Area.id"></el-option>
            </el-select>
          </div>
          <div class="col-sm-1">
            <el-select v-model="filterParam.country" clearable placeholder="请选择縣市">
              <el-option v-for="Area in EventAreaList" :key="Area.id" :label="Area.sgL_NewName"
                :value="Area.id"></el-option>
            </el-select>
          </div>
          <div class="col-sm-2">
            <el-select v-model="filterParam.type" multiple placeholder="请选择活動類型">
              <el-option v-for="item in EventTypeList" :key="item.id" :label="item.sgL_NewName"
                :value="item.id"></el-option>
            </el-select>
          </div>
          <div class="col-sm-2">
            <el-select v-model="filterParam.remark" multiple clearable placeholder="请选择標籤">
              <el-option v-for="Remark in EventRemarkList" :key="Remark.id" :label="Remark.sgL_NewName"
                :value="Remark.id"></el-option>
            </el-select>
          </div>
          <div class="col-sm-2">
            <el-select v-model="filterParam.status" clearable placeholder="報名狀態">
              <el-option v-for="status in EventStatusList" :key="status.id" :label="status.sgL_NewName"
                :value="status.id"></el-option>
            </el-select>
          </div>
          <div class="col-sm-3">
            <el-date-picker v-model="filterParam.activeDate" type="daterange" range-separator="至"
              start-placeholder="活動開始日期" end-placeholder="活動結束日期" value-format="yyyy-MM-dd"></el-date-picker>
            <!-- <el-date-picker
              v-model="filterParam.ApplyDate"
              type="daterange"
              range-separator="至"
              start-placeholder="報名開始日期"
              end-placeholder="報名結束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker> -->
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <el-table :data="EventListModel" :stripe="true" row-key="id" border>
                  <el-table-column label="推薦" align="center" width="30">
                    <template slot-scope="scope">
                      <span v-if="scope.row.sgL_Recommend">
                        <i class="el-icon-star-on"></i>
                      </span>
                      <span v-else>
                        <i class="el-icon-star-off"></i>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="活動日期" align="center" prop="sgL_ActivityDatesZ"></el-table-column>
                  <el-table-column label="活動名稱" align="center" prop="sgL_Title">
                    <template slot-scope="scope">
                      <router-link target="_blank" :to="{
                        name: 'eventview',
                        params: { id: scope.row.id },
                      }">{{ scope.row.sgL_Title }}</router-link>
                    </template>
                  </el-table-column>
                  <el-table-column label="活動類型" align="center" width="60" prop="sgL_TypeF"></el-table-column>
                  <el-table-column label="活動地區" align="center" width="60" prop="sgL_CityF"></el-table-column>
                  <el-table-column label="活動縣市" align="center" width="60" prop="sgL_AreaF"></el-table-column>
                  <el-table-column label="報名狀態" align="center" width="60" prop="sgL_StatusF"></el-table-column>
                  <el-table-column label="報名日期" align="center">
                    <template slot-scope="scope">
                      <span>{{ scope.row.sgL_ApplyDateF }}</span> -
                      <span>{{ scope.row.sgL_EndApplyDateF }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="活動附註" align="center" width="160" prop>
                    <template slot-scope="scope">
                      <span class="b-tag" v-if="scope.row.sgL_NotesName != null">
                        <a v-for="words in scope.row.sgL_NotesName" v-bind:key="words">{{ words }}</a>
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column label="瀏覽量" align="center" width="60" prop="sgL_RView"></el-table-column>
                  <!-- <el-table-column
                    label="讚好"
                    align="center"
                    width="30"
                    prop="sgL_Praise"
                  ></el-table-column>
                  <el-table-column
                    label="留言"
                    align="center"
                    width="60"
                    prop="sgL_Message"
                  ></el-table-column>
                  <el-table-column
                    label="收藏"
                    align="center"
                    width="60"
                    prop="sgL_Favorite"
                  ></el-table-column> -->
                  <el-table-column label="操作" width="280">
                    <template slot-scope="scope">
                      <el-button type="success" size="mini" @click="UpdateRecommend(scope.row.id)"
                        v-if="scope.row.sgL_Recommend == true">從推薦中移除</el-button>
                      <el-button type="primary" size="mini" @click="UpdateRecommend(scope.row.id)" v-else>加入推薦</el-button>
                      <el-button type="primary" size="mini" @click="edit(scope.row.id)">編輯</el-button>
                      <el-button type="danger" size="mini" @click="
                        open(
                          $event,
                          scope.row.id,
                          `您確定將活動[${scope.row.sgL_Title}]刪除？`,
                          '刪除活動',
                          'del'
                        )
                      ">刪除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="row">
                <div class="col-lg-4 offset-lg-7">
                  <!--  引用分页组件 -->
                  <pagination v-if="pageParams.pageshow" :currentPage="pageParams.currentPage" :total="pageParams.total"
                    :limit="pageParams.limit" :small="true" @handleCurrentChange="handleCurrentChange"
                    @handleSizeChange="handleSizeChange" />
                </div>
              </div>
              <!-- /.card-body -->
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
      <!-- Modal: 篩選條件 -->
      <div class="modal fade" id="modal-user--filter">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">篩選條件</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group mb-3">
                <label>活動日期介乎</label>
                <div class="input-group">
                  <input type="text" class="form-control float-right date-range-picker" />
                </div>
              </div>
              <div class="form-group">
                <label>活動名稱</label>
                <div class="input-group mb-3">
                  <input class="form-control" />
                </div>
              </div>
              <div class="form-group mb-3">
                <label>類型（不勾選為全部類型）</label>
                <div class="form-group clearfix mb-3">
                  <div class="row mb-2">
                    <div class="col-3">
                      <div class="icheck-primary d-inline">
                        <input type="checkbox" id="category-1" />
                        <label for="category-1">路跑</label>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="icheck-primary d-inline">
                        <input type="checkbox" id="category-2" />
                        <label for="category-2">鐵人</label>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="icheck-primary d-inline">
                        <input type="checkbox" id="category-3" />
                        <label for="category-3">越野跑</label>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="icheck-primary d-inline">
                        <input type="checkbox" id="category-4" />
                        <label for="category-4">單車</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3">
                      <div class="icheck-primary d-inline">
                        <input type="checkbox" id="category-5" />
                        <label for="category-5">游泳</label>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="icheck-primary d-inline">
                        <input type="checkbox" id="category-6" />
                        <label for="category-6">其他</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>所在地區（預設為所有地區）</label>
                <select class="duallistbox" multiple="multiple">
                  <option>臺灣 - 臺東縣</option>
                  <option>臺灣 - 臺北市</option>
                  <option>臺灣 - 新北市</option>
                  <option>香港 - 新界</option>
                  <option>香港 - 九龍</option>
                  <option>香港 - 香港島</option>
                  <option>澳門</option>
                  <option>海外地區</option>
                </select>
              </div>
              <div class="form-group mb-3">
                <label>報名狀態</label>
                <div class="form-group">
                  <select class="form-control custom-select select2-no-search">
                    <option>所有</option>
                    <option>未開始報名</option>
                    <option>報名開放中</option>
                    <option>已截止報名</option>
                    <option>活動延期</option>
                    <option>活動取消</option>
                  </select>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>報名日期介乎</label>
                <div class="input-group">
                  <input type="text" class="form-control float-right date-range-picker" />
                </div>
              </div>
              <div class="form-group mb-3">
                <label>活動附註（預設為所有地區）</label>
                <select class="duallistbox" multiple="multiple">
                  <option>親子活動</option>
                  <option>國際活動</option>
                  <option>田總認證活動</option>
                </select>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-default" data-dismiss="modal">
                取消
              </button>
              <button type="button" class="btn btn-primary" data-toggle="modal" data-dismiss="modal">
                篩選
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal: 篩選條件 -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import { Message } from "element-ui";
import pagination from "../common/Page";
export default {
  data() {
    return {
      EventList: null,
      EventStatusList: null,
      RemarkList: null,
      EventCityList: null,
      EventRemarkList: null,
      EventAreaList: null,
      EventTypeList: null,
      //分页
      pageParams: {
        currentPage: 1,
        limit: 20,
        total: 2,
        pageshow: true,
      },
      filterParam: {
        title: null,
        country: null,
        type: null,
        activeDate: null,
        area: null,
        status: null,
        remark: null,
        ApplyDate: null,
        Quarter: 0,
      },
    };
  },
  components: {
    pagination,
  },
  watch: {
    "filterParam.title": {
      handler: function (newval, oldval) {
        this.handleCurrentChange(1);
      },
    },
    "filterParam.Quarter": {
      handler: function (newval, oldval) {
        this.handleCurrentChange(1);
      },
    },
    "filterParam.type": {
      handler: function (newval, oldval) {
        this.handleCurrentChange(1);
      },
    },
    "filterParam.status": {
      handler: function (newval, oldval) {
        this.handleCurrentChange(1);
      },
    },
    "filterParam.area": {
      handler: function (newval, oldval) {
        this.getEventArea(newval);
        this.handleCurrentChange(1);
      },
    },
    "filterParam.country": {
      handler: function (newval, oldval) {
        this.handleCurrentChange(1);
      },
    },
    "filterParam.remark": {
      handler: function (newval, oldval) {
        this.handleCurrentChange(1);
      },
    },
    "filterParam.ApplyDate": {
      handler: function (newval, oldval) {
        this.handleCurrentChange(1);
      },
    },
    "filterParam.activeDate": {
      handler: function (newval, oldval) {
        this.handleCurrentChange(1);
      },
    },
    // filterParam:{
    //   handler: function (newval, oldval) {
    //     this.getEventArea(newval.area);
    //     this.handleCurrentChange(1);
    //   },
    //   deep:true
    // }
  },
  created() {
    this.GetEventList();
    this.$store.dispatch("getCommonType", 40).then((res) => {
      this.EventTypeList = res; //活動類型
    });
    this.$store.dispatch("getCommonType", 50).then((res) => {
      this.EventStatusList = res; //活動狀態
    });
    this.$store.dispatch("getCommonType", 60).then((res) => {
      this.EventRemarkList = res; //活動附注
    });
    this.$store.dispatch("getCommonType", 30).then((res) => {
      this.EventCityList = res; //城市
    });
  },
  methods: {
    getEventArea(PId) {
      let params = {
        SGL_TypeT: 30, //城市
        MaxResultCount: 100,
        SGL_ParentID: 1, //區域
        SGL_NewTypeId: PId,
      };
      this.$api.EventApi.GetEventType(params).then((res) => {
        if (res.data.success) {
          this.EventAreaList = res.data.result.items;
        }
      });
    },
    GetEventList() {
      let params = {
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
        SGL_Title: this.filterParam.title,
        SGL_Status: [],
        SGL_ActivityType: this.filterParam.Quarter,
        SGL_AreaId: this.filterParam.area,
        SGL_CityId: this.filterParam.country,
        SGL_ActivityDate: this.filterParam.activeDate,
        SGL_ApplyDate: this.filterParam.ApplyDate,
        SGL_TypeId: this.filterParam.type,
        SGL_NotesId: this.filterParam.remark,
      };
      if (this.filterParam.status) {
        params.SGL_Status = [this.filterParam.status];
      }

      this.$api.EventApi.GetEventList(params).then((res) => {
        if (res.data.success) {
          this.EventList = res.data.result.items;
          this.pageParams.total = res.data.result.totalCount;
        }
      });
    },
    //加入推荐
    UpdateRecommend(id) {
      let params = {
        Id: id,
      };
      this.$api.EventApi.UpdateRecommend(params).then((res) => {
        if (res.data.success) {
          Message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
        } else {
          Message({
            type: "error",
            message: "操作失败",
          });
        }
        this.handleCurrentChange(1);
      });
    },

    //打开模态框
    open(e, Id, operator, title, method) {
      this.$confirm(operator, title, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          if (method == "removeFeatured" || method == "addFeatured") {
          } else {
            await this.DeleteEvent(Id);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "操作取消",
          });
        });
    },
    //删除
    DeleteEvent(Id) {
      let params = {
        Id: Id,
      };
      this.$api.EventApi.DelEvent(params).then((result) => {
        if (result.data.success) {
          Message({
            type: "success",
            message: "刪除成功",
          });
        } else {
          Message({
            type: "warning",
            message: result.data.error.message,
          });
        }
        this.handleCurrentChange(1);
      });
    },
    //根据分类查询数据，更新页码为第一页
    selectByType(typeId) {
      this.filterParam.Quarter = typeId;
      this.filterParam.ApplyDate = null;
      this.filterParam.activeDate = null;
      this.handleCurrentChange(1);
    },
    edit(id) {
      this.$router.push({ name: "EventAdd", query: { Id: id } });
    },
    toEventAdd() {
      this.$router.push({ name: "EventAdd" });
    },
    Delete(id) { },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.GetEventList();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.GetEventList();
    },
  },
  computed: {
    EventListModel() {
      return this.EventList;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/AdminEvent/EventList.vue